export { default } from './NewsletterAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterAdd/index.js